var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"company-page-heading user-requests-heading"},[_c('div',[_c('h1',{attrs:{"id":_vm.titleId}},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"user-requests-count",attrs:{"aria-live":"polite"}},[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }